var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005098",
    fillRule: "evenodd",
    d: "M16.1 6.855a1.25 1.25 0 0 0-.474-.841L13.738 4.53V1.923a.33.33 0 0 0-.33-.33h-1.359a.33.33 0 0 0-.33.33v1.021L9.044.844a1.6 1.6 0 0 0-1.98 0L.483 6.013a1.25 1.25 0 0 0-.473.841c-.04.335.052.665.26.93a1.25 1.25 0 0 0 .995.482c.28 0 .552-.093.777-.27L7.473 3.73a.94.94 0 0 1 1.163 0l5.432 4.267c.265.208.595.3.93.26.334-.04.633-.207.84-.472.209-.265.301-.595.261-.93",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005098",
    fillRule: "evenodd",
    d: "M13.61 8.412 8.67 4.558a1 1 0 0 0-1.23 0L2.498 8.412a.33.33 0 0 0-.127.26v4.397c0 .79.642 1.431 1.43 1.431h2.586a.33.33 0 0 0 .33-.33v-3.08c0-.736.6-1.336 1.337-1.336s1.337.6 1.337 1.337v3.079c0 .182.148.33.33.33h2.586c.789 0 1.43-.642 1.43-1.43V8.671a.33.33 0 0 0-.127-.26",
    clipRule: "evenodd"
  })));
};
export default SvgHome;